import { Button, Group, Stack, Text } from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'
import { CodeSnippet } from '@/components/ui-shared/CodeSnippet/CodeSnippet'
import { PlatformAlert } from '@/components/ui-shared/PlatformAlert/PlatformAlert'
import { WorkspaceApiKeyScope } from '@/types/workspace'
import { getScopeConfig } from './apiKeyUtils'

type ApiKeyCreatedViewProps = {
  keyValue: string
  scope: WorkspaceApiKeyScope
  onClose: () => void
}

export const ApiKeyCreatedView = ({
  keyValue,
  scope,
  onClose
}: ApiKeyCreatedViewProps) => {
  const { ExampleComponent } = getScopeConfig(scope)

  return (
    <Stack gap="xl">
      <PlatformAlert variant="success">
        <FormattedMessage id="workspace.apiKeys.created.description" />
      </PlatformAlert>

      <Stack gap="xs">
        <Text size="sm" fw={600}>
          <FormattedMessage id="workspace.apiKeys.created.keyLabel" />
        </Text>

        <CodeSnippet copyValue={keyValue}>{keyValue}</CodeSnippet>

        <Group gap={4}>
          <IconAlertTriangle
            size={14}
            color="var(--mantine-color-orange-text)"
          />
          <Text size="xs">
            <FormattedMessage id="workspace.apiKeys.created.shownOnce" />
          </Text>
        </Group>
      </Stack>

      <ExampleComponent keyValue={keyValue} />

      <Group justify="end">
        <Button miw={120} onClick={onClose}>
          <FormattedMessage id="done" />
        </Button>
      </Group>
    </Stack>
  )
}
